// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store'

import axios from 'axios'

import './permission' // permission control & routes securing

import firebase from 'firebase'

import Element from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css';
import './styles/global-style.scss'

import './styles/element-ui.scss'

import './styles/icomoon.scss'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import './styles/Mixin.scss'
import 'velocity-animate/velocity'
import VueBulmaAccordion from 'vue-bulma-accordion'
import locale from 'element-ui/lib/locale/lang/en'

import Chartkick from 'chartkick'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
// import './assets/fonts/et-line-font/et-line-font.css'
Vue.use(VueChartkick, {adapter: Chart})

// fire-base configuration
let config = {};

// if (process.env.NODE_ENV !== 'production') {
//   console.log('not production environment')
config = {
  apiKey: "AIzaSyB_Vmv02Fe9Q_BRCu3HlWHS7pvsJmgTdVE",
  authDomain: "tisalabs-iot-platform-dev.firebaseapp.com",
  databaseURL: "https://tisalabs-iot-platform-dev.firebaseio.com",
  projectId: "tisalabs-iot-platform-dev",
  storageBucket: "tisalabs-iot-platform-dev.appspot.com",
  messagingSenderId: "308129866545"
};
firebase.initializeApp(config);

// } else {
//   console.log('production environment')

// axios.get(window.location.origin + '/__/firebase/init.json').then(success => {
//   config = success.data;
//   firebase.initializeApp(config)
//
// }).catch(error => {
//   console.error('unable to get config', error)
// })
// }

Vue.config.productionTip = false;


Vue.use(Element, {
  size: 'medium',// set element-ui default size
  locale
});
Vue.use(VueBulmaAccordion);
Vue.config.performance = process.env.NODE_ENV !== 'production';



new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',

});




// WEBPACK FOOTER //
// ./src/main.js